const mappingElementIdsToTargets = (elementIds, targets) =>
  elementIds.reduce(
    (acc, elementId) => ({
      ...acc,
      [elementId]: targets && elementIds.includes(elementId) ? targets : [],
    }),
    {}
  );

export default mappingElementIdsToTargets;
